import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { SiteFooter, SiteNav } from "@/components/media/SiteNav";
import { Eyebrow, Section } from "@/components/media/Sections";
import { AcademyModules, OperatorPaths, Realities } from "@/components/media/Blocks";
import { ValueStack } from "@/components/ladder/Credibility";
import { LicenseBlock } from "@/components/media/License";

/** How Smash Academy works — the $67 founding membership lives here, not on the homepage. */
export default function AcademyOffer() {
  const site = useSite();
  const [academy, setAcademy] = useState(null);

  useEffect(() => {
    api.get("/products").then(({ data }) => {
      setAcademy((data.products || []).find((p) => p.key === "popup_profits") || null);
    });
  }, []);

  if (!site)
    return (
      <div>
        <SiteNav />
        <div className="mono px-5 py-32 text-center text-sm text-muted-foreground">Loading…</div>
      </div>
    );

  return (
    <div data-testid="academy-offer-page">
      <SiteNav />

      <Section testId="academy-offer-hero">
        <Eyebrow>SMASH ACADEMY</Eyebrow>
        <h1 className="neon mt-3 max-w-4xl text-4xl leading-tight sm:text-5xl lg:text-6xl">
          {site.academyPitch.headline}
        </h1>
        <div className="mt-6 max-w-2xl space-y-4 text-base text-muted-foreground md:text-lg">
          {(site.academyPitch.body || "").split("\n\n").map((p) => (
            <p key={p.slice(0, 24)}>{p}</p>
          ))}
        </div>
        <p className="mono mt-8 text-[11px] leading-relaxed tracking-widest text-muted-foreground">
          FREE FIRST: THE STARTER GUIDE, TEN LESSONS AND THE EVENT ECONOMICS CALCULATOR COST NOTHING.
          <br />
          <Link to="/learn" className="text-primary hover:underline">START THERE →</Link>
        </p>
      </Section>

      <Section testId="academy-offer-modules" tint>
        <AcademyModules pitch={site.academyPitch} />
      </Section>

      <div className="border-b border-border">
        <ValueStack product={academy} />
      </div>

      <Section testId="academy-offer-realities">
        <Realities realities={site.realities} />
      </Section>

      <Section testId="academy-offer-paths" tint>
        <Eyebrow>AFTER THE ACADEMY</Eyebrow>
        <h2 className="neon mt-3 text-4xl leading-tight sm:text-5xl">
          Or build with the Smash brand.
        </h2>
        <p className="mt-5 max-w-2xl text-base text-muted-foreground md:text-lg">
          The Academy teaches you to build your own. Operating under Smash Lemonade is a different
          path — an application and qualification process, never a checkout.
        </p>
        <div className="mt-12">
          <OperatorPaths paths={site.operator_paths || []} disclaimer={site.disclaimer} />
        </div>
      </Section>

      <Section testId="license-section" id="license">
        <LicenseBlock license={site.license} />
      </Section>

      <SiteFooter />
    </div>
  );
}
